<template>
  <v-layout row wrap align-start align-content-start class="mb-2">
    <!-- Title and Actions -->
    <v-flex xs12 class="py-0">
      <v-toolbar color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">group</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          {{ messages.label.PROVIDER_GROUPS }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="showAddProviderGroup">
          <v-icon left>add_circle</v-icon>
          <span>{{ messages.label.PROVIDER_GROUP }}</span>
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-layout>
      <!-- Provider Groups List -->
      <v-flex xs6>
        <ProviderGroupsList />
      </v-flex>
      <!-- Provider Group Sheet -->
      <v-flex xs6 class="side-sheet-container mr-2">
        <ProviderGroupDetails />
      </v-flex>
    </v-layout>
    <!-- Snackbar -->
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="secondary" @click.native="snackbar.show = false">
          {{ messages.label.OK }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import ProviderGroupsList from "@/Providers/ProviderGroups/ProviderGroupsList"
import ProviderGroupDetails from "@/Providers/ProviderGroups/ProviderGroupDetails"
import ProvidersService from "@/Providers/ProvidersService"
import messages from "@/Providers/messages.json"
import AppService from "@/AppService"

/**
 * initialData
 */
function initialData() {
  return {
    snackbar: {
      show: false,
      timeout: 5000,
      message: "",
      color: "error"
    }
  }
}

export default {
  name: "ProviderGroupsHome",
  components: {
    ProviderGroupsList,
    ProviderGroupDetails
  },
  data: function () {
    return initialData()
  },
  methods: {
    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData())
    },

    /**
     * Display side sheet to add a new provider group
     */
    showAddProviderGroup() {
      ProvidersService.$emit("event:showProviderGroupDetailsSheet")
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    AppService.$on("event:preIngestServerError", () => {
      this.snackbar.show = true
      this.snackbar.color = "error"
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })
    ProvidersService.$on("event:templateDeleted", () => {
      this.snackbar.show = true
      this.snackbar.color = "success"
      this.snackbar.message = this.messages.info.TEMPLATE_DELETE_SUCCESS
    })
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style lang="scss">
.side-sheet-container {
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/Providers/ProviderGroups/ProviderGroupsHome.vue